/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Keyword_OptimizerInputs */

const en_nav_keyword_optimizer = /** @type {(inputs: Nav_Keyword_OptimizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Optimizer`)
};

const de_nav_keyword_optimizer = /** @type {(inputs: Nav_Keyword_OptimizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword-Optimierung`)
};

const fr_nav_keyword_optimizer = /** @type {(inputs: Nav_Keyword_OptimizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Optimizer`)
};

const es_nav_keyword_optimizer = /** @type {(inputs: Nav_Keyword_OptimizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Optimizer`)
};

const it_nav_keyword_optimizer = /** @type {(inputs: Nav_Keyword_OptimizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Optimizer`)
};

const nl_nav_keyword_optimizer = /** @type {(inputs: Nav_Keyword_OptimizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Optimizer`)
};

const pl_nav_keyword_optimizer = /** @type {(inputs: Nav_Keyword_OptimizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Optimizer`)
};

const fi_nav_keyword_optimizer = /** @type {(inputs: Nav_Keyword_OptimizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Optimizer`)
};

const da_nav_keyword_optimizer = /** @type {(inputs: Nav_Keyword_OptimizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Optimizer`)
};

const sv_nav_keyword_optimizer = /** @type {(inputs: Nav_Keyword_OptimizerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyword Optimizer`)
};

/**
* | output |
* | --- |
* | "Keyword Optimizer" |
*
* @param {Nav_Keyword_OptimizerInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const nav_keyword_optimizer = /** @type {((inputs?: Nav_Keyword_OptimizerInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Keyword_OptimizerInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nav_keyword_optimizer(inputs)
	if (locale === "fr") return fr_nav_keyword_optimizer(inputs)
	if (locale === "es") return es_nav_keyword_optimizer(inputs)
	if (locale === "it") return it_nav_keyword_optimizer(inputs)
	if (locale === "nl") return nl_nav_keyword_optimizer(inputs)
	if (locale === "pl") return pl_nav_keyword_optimizer(inputs)
	if (locale === "fi") return fi_nav_keyword_optimizer(inputs)
	if (locale === "da") return da_nav_keyword_optimizer(inputs)
	if (locale === "sv") return sv_nav_keyword_optimizer(inputs)
	return en_nav_keyword_optimizer(inputs)
});